import React from "react";
import universalstorageHandler from "../persistence/UniversalstorageHandler";
import { showToast } from "./Toasts";
import { channelTypeInfo } from "../models/ChannelType";
import AskIfSnapshotShouldBeSavedDialog from "./dialogs/AskIfSnapshotShouldBeSaved";
import { itx } from "../translationItx/itx";

export async function saveProject(showErrors?: boolean) {
  showErrors = showErrors === undefined ? true : showErrors;
  if (state.projectMetadata.id.includes("-snapshot")) {
    // first ask if an older version should be saved
    state.dialogManager.openDialog(<AskIfSnapshotShouldBeSavedDialog />);
    return false;
  }

  // if (
  //   state.loggedInUser.abo == "no" &&
  //   state.allDevices().filter((dev) => !channelTypeInfo(dev.channelType).isSupply).length > 10
  // ) {
  //   //state.dialogManager.openDialog(<SavingBecausOfToMuchDevicesNotAllowedDialog />);
  //   showToast({
  //     text: itx(
  //       "saveProject.tooManyDevicesForNoAbo",
  //       "Für Projekte mit mehr als 10 Geräten wird zum öffnen ein Abo benötigt",
  //     ),
  //   });
  // }

  try {
    const status = await universalstorageHandler.saveProject(showErrors);
    if (status) {
      showToast({
        text: state.translate("saveProject.projectSaved", "Ihr Projekt wurde gespeichert"),
      });
    }
    return status;
  } catch (ex: any) {
    var errmsg = ex.message;
    if (!ex.message) {
      errmsg = navigator.onLine ? "" : state.translate("saveProject.netWorkError", ": Netzwerkfehler");
    }
    showToast({
      isError: true,
      text: state.translate("saveProject.projectCoudnTSaveT1", `Ihr Projekt konnte NICHT gespeichert werden T1`, {
        T1: errmsg,
      }),
    });
    return false;
  }
}
